<template>
  <div class="kategorije page-view">
    <ejs-grid :dataSource="this.$store.state.categories" :rowSelected='rowSelected' :rowDeselected='rowDeselected' :allowTextWrap="true">
      <e-columns>
        <e-column headerText='Naziv' field='Name' textAlign='Left'></e-column>
        <e-column headerText='WebID' field='webID' textAlign='Center'></e-column>
        <e-column headerText='Redosljed' field='Prio' textAlign='Right'></e-column>
      </e-columns>
    </ejs-grid>
    <p style="font-size: 0.8rem; text-align: center;">Ukupno kategorija: {{ brojKategorija }} </p>
    <div  id=categories-add-icon v-bind:class="{ transparent: this.isScrolling }" @click="onAdd">
      <img class=custom-icon-shadow src='img/plus.png' width="50" height="50"/>
    </div>
    <div id=row-icons>
      <img class=custom-icon-shadow src='img/edit.png' width="36" height="36" @click="onEdit" v-bind:class="{ hidden: !this.selectedCategoriesID, transparent: this.isScrolling }"/>
      <img class=custom-icon-shadow src='img/remove.png' width="36" height="36" @click="onDeleteClick" v-bind:class="{ hidden: !this.selectedCategoriesID, transparent: this.isScrolling }"/>
    </div>
  </div>
</template>

<style lang="scss"> 
#categories-add-icon {
    position: fixed;
    right: 25px;
    bottom: 35px;
    transition: 0.3s ease-out opacity;
}
</style>

<script>
import Vue from 'vue';

export default {
  name: 'categories_list',
  data() {
    return {
      selectedCategory: null,
      isScrolling: false,
      scrollDelay: null,
    }
  },
  mounted() {
    this.$store.state.hideReturnIcon = false;
    this.$store.state.hideSettingIcon = false;
    this.$store.state.hideFloatWidgetRight = true;
    this.$store.state.hideCloseIcon = true;
    this.$store.state.currentView = 'kategorije';
    this.$store.state.previousView = 'flota';
    this.$store.state.viewTitle = 'Kategorije';
    this.$store.dispatch('getCategories').catch(err => this.$parent.showNotification(err));
  },
  computed: {
    brojKategorija() {
      if (this.$store.state.categories) {
        if (this.$store.state.categories.length) return this.$store.state.categories.length;
      }
      return 0;
    },
    selectedCategoriesID() {
      if (this.selectedCategory) return this.selectedCategory.ID;
      else return 0;
    }
  },
  methods: {
    onAdd(){
      this.$store.state.selectedCategory = null;
      this.$router.push('kategorija');
    },
    onEdit() {
      this.$router.push('kategorija');
    }, 
    onDeleteClick() {
      this.$parent.showPopup(this, 'Želite li obrisati kategoriju: ' + this.selectedCategory.Name);
    },
    async onDelete() {
       await this.$store.dispatch('deleteCategories', { ID : this.selectedCategory.ID }).then(res => this.$parent.showNotification(res)).catch(err => this.$parent.showNotification(err));
       this.$store.dispatch('getCategories').catch(err => this.$parent.showNotification(err));
    },
    rowSelected(args) {
      this.selectedCategory = args.data;
      this.$store.state.selectedCategory = this.selectedCategory;
    },
    rowDeselected() {
      this.selectedCategory = null;
      this.$store.state.selectedCategory = this.selectedCategory;
    },
    onWindowScroll() {
      this.isScrolling = true;
      clearInterval(this.scrollDelay); 
      this.scrollDelay = setTimeout(()=> {
        this.isScrolling = false;
      }, 100);
    },
  },
  created() {
    //window.addEventListener('scroll', this.onWindowScroll);
  },
  destroyed() {
    //window.removeEventListener('scroll', this.onWindowScroll);
  }
}
</script>